import { render, staticRenderFns } from "./ImproveOptions.vue?vue&type=template&id=57854339"
import script from "./ImproveOptions.vue?vue&type=script&lang=js"
export * from "./ImproveOptions.vue?vue&type=script&lang=js"
import style0 from "./ImproveOptions.vue?vue&type=style&index=0&id=57854339&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57854339')) {
      api.createRecord('57854339', component.options)
    } else {
      api.reload('57854339', component.options)
    }
    module.hot.accept("./ImproveOptions.vue?vue&type=template&id=57854339", function () {
      api.rerender('57854339', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/price/ImproveOptions.vue"
export default component.exports